module.exports = __webpack_public_path__ + "hbomaxar-static/media/superintelligence.ade8da72.mp4";